module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S10 Prism White.e46694c4.png";